import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ClmClaimDetails } from '../../models/claim/clmclaimdetails';

@Injectable()
export class ClaimService {

  constructor(private http: HttpClient) {
  }

  SendClaimRequest(claimDetailsObj: ClmClaimDetails) {

   // return null;
    return this.http.post("/Api/Claim/SendClaimRequest", claimDetailsObj)
   // return this.http.get("/Api/Claim/SendClaimRequest")
      .map((res: Response) => {

        return res;
      });
  }

}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/services/claim/claim.service.ts